module.exports = __webpack_public_path__ + "static/media/IvyMode-Light.903a4715.ttf";